import React from 'react'

import { Grid, Paper, IconButton, Typography } from '@mui/material'
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle'

export default function CrewAssignment({ variant, data, onRemoveAction, children }) {

    switch (variant) {

        case 'job-day':
            return (<Grid container spacing={4}>
                <Grid item xs={1}>
                    <IconButton onClick={onRemoveAction}>
                        <RemoveCircleIcon color='error' />
                    </IconButton>
                </Grid>
                <Grid item xs={11}>
                    <Paper variant='outlined' sx={{ padding: 2, marginBottom: 2}}>
                        <Grid container xs={12} alignItems={'center'}>
                            <Grid item xs={9}>
                                <Typography variant="h6">{data.title}</Typography>
                            </Grid>
                            <Grid item xs={3} textAlign={'right'}>
                                <Typography variant="caption">{data.subTitle}</Typography>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>)

        case 'approve-time-tickets':
            return (<Grid container spacing={4}>
                <Grid item xs={11}>
                    <Paper variant='outlined' sx={{ padding: 2, marginBottom: 2}}>
                        <Grid container xs={12} alignItems={'center'}>
                            <Grid item xs={9}>
                                <Typography variant="h6">{data.title}</Typography>
                                <Typography variant="caption">{data.subTitle}</Typography>
                            </Grid>
                            <Grid item xs={3} textAlign={'right'}>
                                <Typography color={data.isGood ? "green" : "red"} variant="body2">
                                    {data.isGood ? data.rightLabelGood : data.rightLabelBad}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>)

        case 'finish-time-tickets':
            return (<Grid container spacing={4}>
                <Paper variant='outlined' sx={{ padding: 2, marginBottom: 2 }}>
                    <Grid container xs={12} alignItems={'center'} rowSpacing={2}>
                        <Grid item xs={9}>
                            <Typography variant="h6">{data.title}</Typography>
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="caption">{data.subTitle}</Typography>
                        </Grid>
                        <Grid>
                            {
                                children.map(child => (<React.Fragment>{child}</React.Fragment>))
                            }
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>)

        case 'mark-as-paid':
            return (<Grid container spacing={4}>
                <Grid item xs={11}>
                    <Paper variant='outlined' sx={{ padding: 2, marginBottom: 2}}>
                        <Grid container xs={12} alignItems={'center'}>
                            <Grid item xs={9}>
                                <Typography variant="h6">{data.title}</Typography>
                                <Typography variant="caption">{data.subTitle}</Typography>
                            </Grid>
                            <Grid item xs={3} textAlign={'right'}>
                                <Typography color={data.isGood ? "green" : "red"} variant="body2">
                                    {data.isGood ? data.rightLabelGood : data.rightLabelBad}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>)

        default:
            return null
    }
}